// components/profile/edit
/* global DEBUG */

import template from './template.jade'
import style    from './style.scss'
import Store    from 'Store'

var name = 'profile/edit'
var url = '/api/profile-edit'
const store = new Store(name)

export default {

  name: name,
  template: template({style: style}),
  props: [],

  data: () => ({
    name: name,
    url: url,
    show: true,
    blockForm: false,
    profile: {},
  }),

  ready() {
    var profile = store.$get('profile/info')
    this.$set('data', profile)

    this.profileEdit = Object.assign({}, profile.table.tbody)
  },

  methods: {
    submit(e) {
      e.preventDefault()
      var formData = new FormData()
      // Profile[file] - имя формы для Yii2 для файла
      formData.append('Profile[file]', this.file)
      formData.append('name_expeditor', store.$get('name_expeditor') )
      formData.append('email', store.$get('email') )
      formData.append('phone', store.$get('phone') )
      for (var item in this.profileEdit) {
        // если есть галочка для изменения данных
        this.profile[item] && formData.append(item, this.profileEdit[item])
      }
      //DEBUG && console.log('formData = ', formData.values())
      this.$set('data', formData)
      store.$save(this)
      this.blockForm = true
      // Обнулимся
      this.file = this.data = false
      this.profile = {}
    },
    // обрабатываем файл из формы
    // https://github.com/vuejs/Discussion/issues/24
    upload(e) {
      e.preventDefault()
      var file = this.$$.profile.files[0]
      //DEBUG && console.log(file)
      if (file.size > 5*1024*1024) {
        alert ('Размер вложения не должен превышать 5MB !')
      } else {
        this.$set('file', file)
      }
    },
  },

  computed: {
    // если хоть один чекбокс true
    profiles() {
      var profile = this.$get('profile')
      for (var key in profile) {
        if (profile[key]) return true
      }
      return false
    }
  },

  events: {
    // если все ок, скроем поля формы
    'fetchData:error': function() {
      this.$set('blockForm', false)
    },
    // если все ок, скроем поля формы
    'fetchData:ok': function() {
      this.$set('blockForm', false)
      this.$set('show', false)
    },
  },
}



/** WEBPACK FOOTER **
 ** ./src/js/components/profile/edit/index.js
 **/